// frontend/src/utils/api.js
// Wrapper para fetch - MODO DEMO: usa mockApi en lugar de backend real

import { mockFetch, shouldUseMock } from './mockApi';
import { getDemoToken } from './mockAuth';

// En modo demo, siempre usamos el mock
const DEMO_MODE = true;

export async function fetchAuth(input, init = {}) {
  // Modo demo: usar API mock
  if (DEMO_MODE && shouldUseMock(input)) {
    console.log('🎮 Demo Mode - Mock fetch:', input);
    return mockFetch(input, init);
  }

  // Fallback al comportamiento original (no debería ejecutarse en demo)
  const token = getDemoToken();
  
  if (!token) {
    const err = new Error('No hay sesión activa. Inicia sesión e intenta nuevamente.');
    err.status = 401;
    throw err;
  }

  // En modo demo, todas las rutas API deberían pasar por mockFetch
  console.warn('⚠️ Ruta no manejada por mock:', input);
  return mockFetch(input, init);
}
